<div class="loadable w-100 responsive-grid" [class.loading]="!isParentLoading && isLoading">
    <div class="actions-container">
        <div class="filter-container">
            <app-search
                placeholder="{{ 'search' | translate }}"
                (onSearch)="onFilterTextBoxChanged($event)"
            ></app-search>
            <app-filter class="bordered" [groups]="externalFilters" (filter)="updateExternalFilters()"></app-filter>

            <!-- TODO: This functionality is not yet implemented -->
            <!-- <ui-button type="primary" [disabled]="true">
                <mat-icon [svgIcon]="fullscreen ? 'collapse' : 'expand'" />
                <span translate="payroll.run.table.{{ fullscreen ? 'exitFullscreen' : 'openFullscreen' }}"
                    >{{ 'payroll.run.table.exitFullscreen' | translate }}
                </span>
            </ui-button> -->

            <ui-button class="margin-left-2" type="outline" [matMenuTriggerFor]="editIncomeTypesMenu">
                {{ 'payroll.run.table.editIncomeDropdown' | translate }}
                <mat-icon svgIcon="chevronDown"></mat-icon>
            </ui-button>
            <ui-button type="outline" [matMenuTriggerFor]="editOtherIncomeTypesMenu">
                {{ 'payroll.run.table.editOtherIncomeDropdown' | translate }}
                <mat-icon svgIcon="chevronDown"></mat-icon>
            </ui-button>
        </div>
        <div class="saving-indicator" [class.error]="hasError">
            {{
                (hasError
                    ? 'payroll.run.table.someCellsHaveErrors'
                    : isSaving
                      ? 'payroll.run.table.saving'
                      : 'payroll.run.table.allChangesSaved'
                ) | translate
            }}
        </div>
    </div>
    <ng-container *ngIf="!isLoading">
        <!--Ag-grid table-->
        <form *ngIf="showForm" #form="ngForm">
            <ag-grid-angular
                class="ag-theme-quartz dark"
                style="width: 100%; height: 55vh"
                [suppressFieldDotNotation]="true"
                [columnDefs]="columnDefs"
                [rowData]="rowData"
                [getRowId]="getRowId"
                [suppressRowTransform]="true"
                [paginationPageSize]="20"
                (sortChanged)="onSortChanged($event)"
                (filterChanged)="onFilterChanged($event)"
                [isExternalFilterPresent]="isExternalFilterPresent"
                [doesExternalFilterPass]="doesExternalFilterPass"
                (gridReady)="onGridReady($event)"
                (bodyScroll)="onBodyScroll($event)"
            />
        </form>
    </ng-container>
</div>
<mat-menu #editIncomeTypesMenu="matMenu">
    @for (visibility of incomeTypesVisibility; track visibility.groupName) {
        <div mat-menu-item>
            <mat-checkbox
                [(ngModel)]="visibility.visible"
                (change)="setIncomeTypeVisibility(visibility.groupName, $event.checked)"
            >
                {{ visibility.groupName }}
            </mat-checkbox>
        </div>
    }
</mat-menu>

<mat-menu #editOtherIncomeTypesMenu="matMenu">
    @for (visibility of otherIncomeTypesVisibility; track visibility.displayName) {
        <div mat-menu-item>
            <mat-checkbox
                [(ngModel)]="visibility.visible"
                (change)="setOtherIncomeTypeVisibility(visibility.columnId, $event.checked)"
            >
                {{ visibility.displayName }}
            </mat-checkbox>
        </div>
    }
</mat-menu>
